// extracted by mini-css-extract-plugin
module.exports = {"mobiletable":"mobiletable__3hGxE"};